class AnnouncementBar extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.announcement__slide'));
    if (this.slides.length < 2) return;

    this.index = 0;
    this.delay = (parseInt(this.getAttribute('autorotate'), 10) || 0) * 1000;

    this.addEventListener('click', (event) => {
      const button = event.target.closest('button[name]');
      if (!button) return;
      this.go(button.name === 'next' ? 1 : -1);
      this.restart();
    });

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (this.delay && !reduceMotion) {
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
      this.start();
    }
  }

  go(direction) {
    this.slides[this.index].hidden = true;
    this.index = (this.index + direction + this.slides.length) % this.slides.length;
    this.slides[this.index].hidden = false;
  }

  start() {
    if (this.delay && !this.timer) this.timer = setInterval(() => this.go(1), this.delay);
  }

  stop() {
    clearInterval(this.timer);
    this.timer = null;
  }

  restart() {
    this.stop();
    this.start();
  }

  disconnectedCallback() {
    this.stop();
  }
}
customElements.define('announcement-bar', AnnouncementBar);
